export default __webpack_public_path__ + "static/hub-9a5d6d6d421cccc6c99a929ed6228e95.png";